import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  tabsNavigationsContainer: {
    '& .MuiTab-root': {
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 400,
      textTransform: 'capitalize',
      color: '#000',
      borderBottom: `1px solid ${theme.app.colors.border.light}`
    },

    '& .Mui-selected': {
      color: theme.palette.primary.main
    },

    '& .MuiTabs-scrollButtonsDesktop': {
      display: 'none'
    }
  },

  viewContainer: {
    padding: '22px 0 33px 0',
    height: '100%'
  },

  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh'
  }
}))
